import moment from "moment";
import { processDateRange } from "./dateUtils";

interface IdObject {
  id: string | number;
}

export interface FilterItem {
  key: string;
  type: string;
  label: string;
  placeholder?: string;
  value: string | number | boolean | Date | IdObject | (string | number | boolean | Date | IdObject)[];
  options?: { label: string; value: string | number | boolean }[];
}

function isEmpty(value: unknown): boolean {
  if (value === null || value === undefined || value === '') return true;
  if (Array.isArray(value) && value.length === 0) return true;
  if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value as object).length === 0) return true;
  return false;
}

export function buildFilterObject(
  filterConfig: FilterItem[],
  pagination: { page: number; pageSize: number; sort?: string | null } = { page: 1, pageSize: 10, sort: null }
): Record<string, unknown> {
  return {
    ...pagination,
    ...filterConfig.reduce((acc: Record<string, unknown>, item) => {
      if (item.key === 'registerDate' && item.type === 'date-range' && Array.isArray(item.value)) {
        const result = processDateRange(item.value as (string | Date)[], 'create_date_from', 'create_date_to');
        if (result.fromValue) acc[result.fromKey] = result.fromValue;
        if (result.toValue) acc[result.toKey] = result.toValue;
      } else if(item.key === 'requestDate' && item.type === 'date-range' && Array.isArray(item.value)) {
        const result = processDateRange(item.value as (string | Date)[], 'kyc_request_date_from', 'kyc_request_date_to');
        if (result.fromValue) acc[result.fromKey] = result.fromValue;
        if (result.toValue) acc[result.toKey] = result.toValue;
      } else if (item.key === 'transaction_date' && item.type === 'date-range' && Array.isArray(item.value)) {
        const result = processDateRange(item.value as (string | Date)[], 'date_from', 'date_to');
        if (result.fromValue) acc[result.fromKey] = result.fromValue;
        if (result.toValue) acc[result.toKey] = result.toValue;
      } else if (item.key === 'end_date' && item.type === 'date-range' && Array.isArray(item.value)) {
        const result = processDateRange(item.value as (string | Date)[], 'start_date', 'end_date', 'YYYY-MM-DD HH:mm');
        if (result.fromValue) acc[result.fromKey] = result.fromValue;
        if (result.toValue) acc[result.toKey] = result.toValue;
      } else if (item.key === 'completed_end' && item.type === 'date-range' && Array.isArray(item.value)) {
        const result = processDateRange(item.value as (string | Date)[], 'completed_start', 'completed_end', 'YYYY-MM-DD HH:mm');
        if (result.fromValue) acc[result.fromKey] = result.fromValue;
        if (result.toValue) acc[result.toKey] = result.toValue;
      } else if (item.key === 'province_id' && item.type === 'region-level-1' && Array.isArray(item.value)) {
        const firstValue = item.value[0] as IdObject;
        acc['province_id'] = firstValue?.id;
      } else if (item.key === 'district_id' && item.type === 'region-level-2' && Array.isArray(item.value)) {
        const firstValue = item.value[0] as IdObject;
        acc['district_id'] = firstValue?.id;
      } else if(item.key === 'higher_broker_id' && item.type === 'account-broker-selector' && Array.isArray(item.value)) {
        const firstValue = item.value[0] as IdObject;
        acc['higher_broker_id'] = firstValue?.id;
      } else if(item.key === 'price' && item.type === 'price-range' && Array.isArray(item.value)) {
        console.log('Price range filter value:', item.value.from, item.value.to);
        if (item.value.from) acc['price_from'] = item.value?.from || 0;
        if (item.value.to) acc['price_to'] = item.value?.to || null;
      } else if (!isEmpty(item.value)) {
        acc[item.key] = item.value;
      }
      return acc;
    }, {}),
  };
}
